import React,{Component} from 'react';
import {Form,Input} from 'antd'
import {Button} from '@material-ui/core'
import firebase from '../../config'
import '../../App.css'
export default class Add extends Component{
    constructor(props){
        super(props)
    }
    onFinish = values =>{
        console.log(this.props.match.params.type)
        firebase.firestore().collection("tests").doc(this.props.match.params.type).collection(values.name).doc("details").set(values).then(doc =>{
            alert("added")
        })
    }
    render(){
        return(
            <div>
                <Form onFinish={this.onFinish}>
                    <Form.Item name="name" label="name">
                        <Input />
                    </Form.Item>
                    <Form.Item name="data" label="details">
                        <Input />
                    </Form.Item>

                    <Form.Item name="name" details="details">
                        <Button variant="contained" color="primary" type="primary" htmlType="submit">Submit</Button>
                    </Form.Item>
                </Form>
            </div>
        )
    }
}